export default {
  api: '',
  version: '',
  appName: '',
  appEmail: '',
  notificationsLoop: 10000,
  serverVersions: '',
  notificationsSocket: ''
}



// WEBPACK FOOTER //
// ./src/store/settings/state.js